import 'whatwg-fetch';
import React from 'react';
import ReactDOM from 'react-dom';

import 'typeface-roboto';
import './styles/global.css';

import configureStore from './configureStore';
import Root from './containers/Root';

const store = configureStore();

ReactDOM.render(
  <Root store={store} />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js